import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const baserow = defineConnector({
  identifier: "baserow",
  name: "Baserow",
  tagLine: "Open source no-code database",
  logo,
  protocol: "http",
  tags: ["productivity", "data"],
  defaultUrlPattern: () => "https://api\\.baserow\\.io/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.token,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Enter your Baserow instance URL",
      items: [
        {
          kind: "baseUrl",
          label: "Instance URL",
          required: true,
          placeholder: "https://api.baserow.io",
          defaultValue: "https://api.baserow.io",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText:
            "Your Baserow API URL. Use https://api.baserow.io for hosted Baserow, or your self-hosted instance URL.",
        },
      ],
    },
    {
      title: "Get a database token",
      items: [
        {
          kind: "markdown",
          content:
            "In Baserow, click your profile icon, then select 'Settings' and 'Database tokens'. Create a new token with the permissions you need.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Database token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl}/api/database/rows/table/1/?size=1`,
  },
  publicEnvVars: ({ instanceUrl }) => ({ BASEROW_URL: instanceUrl || "" }),
});
